import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34c805e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page min-h-100" }
const _hoisted_2 = { class: "page__content d-flex flex-column justify-content-between min-h-100" }
const _hoisted_3 = { class: "p-0 px-md-2 overflow-x-hidden" }
const _hoisted_4 = { class: "sticky-bottom-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiBsHeader = _resolveComponent("AsahiBsHeader")!
  const _component_AsahiOrderInformation = _resolveComponent("AsahiOrderInformation")!
  const _component_OnBehalfOrder = _resolveComponent("OnBehalfOrder")!
  const _component_BreadcrumbLayout = _resolveComponent("BreadcrumbLayout")!
  const _component_AsahiBsFooter = _resolveComponent("AsahiBsFooter")!
  const _component_AsahiBsNav = _resolveComponent("AsahiBsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_AsahiBsHeader, {
          "header-data": _ctx.portalPageMenuLink,
          "cart-item": _ctx.items,
          "favorite-item": _ctx.favoritesItems,
          "cart-number": _ctx.cartItems,
          user: _ctx.user,
          "catalog-permission": _ctx.catalogPermission,
          onRemovefromcart: _cache[0] || (_cache[0] = (event) => _ctx.removeProductFromCart(event?.detail))
        }, null, 8, ["header-data", "cart-item", "favorite-item", "cart-number", "user", "catalog-permission"]),
        (!_ctx.isMobile && (!_ctx.isBasicCustomer && !_ctx.isStandardOntrade && !_ctx.allowedPages.includes(_ctx.$route.name) && !_ctx.isOnNoStickyBarPage))
          ? (_openBlock(), _createBlock(_component_AsahiOrderInformation, {
              key: 0,
              class: "asahi-order-information hidden-on-small-screen",
              "header-data": _ctx.portalPageMenuLink,
              "right-menu": _ctx.rightMenu,
              "cart-item": _ctx.items,
              "favorite-item": _ctx.favoritesItems,
              "cart-number": _ctx.cartItems,
              user: _ctx.user,
              "catalog-permission": _ctx.catalogPermission,
              onRemovefromcart: _cache[1] || (_cache[1] = (event) => _ctx.removeProductFromCart(event?.detail)),
              onShipToChange: _cache[2] || (_cache[2] = (e) => _ctx.fetchPendingOrders(e))
            }, null, 8, ["header-data", "right-menu", "cart-item", "favorite-item", "cart-number", "user", "catalog-permission"]))
          : _createCommentVNode("", true),
        (!_ctx.isOnTradeCustomer && _ctx.pendingOrderList.length > 0)
          ? (_openBlock(), _createBlock(_component_OnBehalfOrder, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("main", _hoisted_3, [
          _createVNode(_component_BreadcrumbLayout),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_AsahiBsFooter, {
          onLanguagechange: _ctx.changeLanguage,
          language: _ctx.languages,
          "active-language": _ctx.activeLanguage,
          user: _ctx.user,
          "footer-data": _ctx.portalPageMenuLink,
          "brand-data": _ctx.footerLinksBrands,
          "header-data": _ctx.portalPageMenuLink,
          cookies: _ctx.footerLinksCookies,
          "terms-of-use": _ctx.footerLinksTermsOfUse,
          "privacy-policy": _ctx.footerLinksPrivacyPolicy
        }, null, 8, ["onLanguagechange", "language", "active-language", "user", "footer-data", "brand-data", "header-data", "cookies", "terms-of-use", "privacy-policy"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isMobile && (!_ctx.isBasicCustomer &&!_ctx.isStandardOntrade && !_ctx.allowedPages.includes(_ctx.$route.name)))
        ? (_openBlock(), _createBlock(_component_AsahiOrderInformation, {
            key: 0,
            class: "hidden-on-big-screen",
            "header-data": _ctx.portalPageMenuLink,
            "right-menu": _ctx.rightMenu,
            "cart-item": _ctx.items,
            "favorite-item": _ctx.favoritesItems,
            "cart-number": _ctx.cartItems,
            user: _ctx.user,
            "catalog-permission": _ctx.catalogPermission,
            "is-mobile": true,
            onRemovefromcart: _cache[3] || (_cache[3] = (event) => _ctx.removeProductFromCart(event?.detail))
          }, null, 8, ["header-data", "right-menu", "cart-item", "favorite-item", "cart-number", "user", "catalog-permission"]))
        : _createCommentVNode("", true),
      _createVNode(_component_AsahiBsNav, {
        "header-data": _ctx.portalPageMenuLink,
        "right-menu": _ctx.rightMenu,
        "cart-item": _ctx.items,
        "favorite-item": _ctx.favoritesItems,
        "cart-number": _ctx.cartItems,
        user: _ctx.user,
        "catalog-permission": _ctx.catalogPermission,
        onRemovefromcart: _cache[4] || (_cache[4] = (event) => _ctx.removeProductFromCart(event?.detail))
      }, null, 8, ["header-data", "right-menu", "cart-item", "favorite-item", "cart-number", "user", "catalog-permission"])
    ])
  ]))
}